import { ApiService }      from '../../app-lite/api/api.service';
import { CodeTypeModel }   from '../../app-lite/core/models/code-type';
import { ConfirmService }  from '../../app-lite/messages/confirm/confirm.service';
import { MessagesService } from '../../app-lite/messages/messages.service';
import { UserModel }       from '../../app-lite/users/models/user';

import MechanicSearchResultsHtml from '../mechanics/templates/mechanic.search.results.html';

interface MobileUserScope extends ng.IScope {
  delete                          : () => void;
  form                            : ng.IFormController;
  isAdvancedUser                  : () => boolean;
  isMobileMechanic                : () => boolean;
  mechanic                        : any;
  mechanicSearch                  : any;
  mechanicSearchResultsTemplateUrl: string;
  save                            : () => void;
  status_types                    : Array<CodeTypeModel>;
  user                            : UserModel;
};

export function MobileUserCtrl (
  $q          : ng.IQService,
  $rootScope  : any,
  $scope      : MobileUserScope,
  $state      : ng.ui.IStateService,
  $translate  : ng.translate.ITranslateService,
  confirm     : ConfirmService,
  mechanic    : any,
  messages    : MessagesService,
  streamSearch: any,
  user        : UserModel,
  workshopAPI : ApiService
) {

  $scope.mechanicSearchResultsTemplateUrl = MechanicSearchResultsHtml;

  $scope.mechanic = mechanic || {
    display_name: user ? `${user.first_name} ${user.last_name}` : '',
    id          : user ? user.mechanic_id : ''
  };

  $scope.user = user || {
    mobile_dealer: $rootScope.Company.hasDealership(),
    state        : $translate.instant('USER_STATE_TYPES.ACTIVE')
  };

  $scope.user.confirm_password      = $scope.user.password;
  $scope.user.mobile_mechanic       = !!($rootScope.Company.hasWorkshop() && $scope.mechanic.id);
  $scope.user.first_name            = $scope.mechanic.first_name;
  $scope.user.last_name             = $scope.mechanic.last_name;
  $scope.user.mechanic_display_name = $scope.mechanic.display_name;
  $scope.user.mechanic_id           = $scope.mechanic.id;

  $scope.mechanicSearch = {
    list    : [],
    selected: {
      display_name: $scope.mechanic.display_name,
      id          : $scope.mechanic.id
    },
    search: ( typed : string ) => {
      return streamSearch.search('mechanics', typed)
      .then(( mechanics : Array<any> ) => $q.when($scope.mechanicSearch.list.concat(mechanics)));
    },
    format: ( mechanic : any ) => angular.isObject(mechanic) ? mechanic.display_name : mechanic,
    choose: ( mechanic : any ) => {
      $scope.user.first_name            = mechanic.first_name;
      $scope.user.last_name             = mechanic.last_name;
      $scope.user.mechanic_display_name = mechanic.display_name;
      $scope.user.mechanic_id           = mechanic.id;
    }
  };

  $scope.delete = function () {
    confirm.generic($translate.instant('JS_SPACE.CONFIRM.DELETE_USER'))
    .then(() => workshopAPI.delete('/mobile_users', $scope.user.id))
    .then(() => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.DELETED.USER'), 'success');

      $state.go('app.users');
    })
    .catch(( err : any ) => {
      messages.error(err);
    });
  };

  $scope.isAdvancedUser = function () {
    return $scope.user.advanced_mobile_user;
  };

  $scope.isMobileMechanic = function () {
    return user.mobile_mechanic;
  }

  $scope.save = function ( form : ng.IFormController = $scope.form ) {
    const method = $scope.user.id ? 'patch': 'post';
    const url    = $scope.user.id ? '/mobile_user': '/mobile_users';

    if (!$scope.user.mobile_mechanic) {
      delete $scope.user.mechanic_id;
    }

    workshopAPI[method](url, $scope.user, 'mobile_user')
    .then(( user : UserModel ) => {
      messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.USER'), 'success');

      form.$setPristine();

      $state.go('app.mobile-user', {
        id         : user.id,
        mechanic_id: user.mechanic_id
      }, {
        reload: true
      });

      $scope.user = user;
    })
    .catch(( err : any ) => {
      messages.error(err);
    });
  };

  workshopAPI.get('/system/user_state_types')
  .then(( types : Array<CodeTypeModel> ) => {
    $scope.status_types = types;
  });
}